import BaseModel from "../BaseModel";
import NameType from "./NameType";
import Customer from "./Customer";
import Address from "./Address";

export default class Name extends BaseModel{
    static entity = 'names';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            name: this.attr(null),
            name_type_id: this.attr(null),
            user_id: this.attr(null),
            name_type: this.belongsTo(NameType, 'name_type_id'),
            customer: this.belongsTo(Customer, 'customer_id'),
            address: this.hasMany(Address, 'customer_id', 'customer_id'),
        }
    }
    
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'name_type', 'customer']
    }
    static route(){
        return '/names'
    }
}
